/**
 * +tutorial: the "Coach" box on Run Rewards: 1–2 tips from the run that just ended, for a player's
 * first COACH_RUNS runs (tutorial/coach.ts). Renders nothing when there is nothing to say.
 */
import { el } from '../meta/ui/dom';
import { kmIcon } from '../meta/kmmo';
import { takeCoachTips } from './coach';
import { renderKeyText } from './overlay';
import './tutorial.css';

export function coachPanel(parent: HTMLElement, before?: Element | null): HTMLElement | null {
  let tips: string[] | null = null;
  try {
    tips = takeCoachTips();
  } catch (err) {
    console.warn('[coach] tips failed', err);
  }
  if (!tips?.length) return null;
  const box = el('div', 'tut-coach');
  if (before && before.parentElement === parent) parent.insertBefore(box, before);
  else parent.appendChild(box);
  const head = el('div', 'tut-coach-head', box);
  head.appendChild(kmIcon('skills'));
  el('span', '', head, 'Coach');
  for (const t of tips) renderKeyText(el('p', 'tut-coach-tip', box), t);
  return box;
}
